import {
  axios
} from '../http'
import config from '../config'
// 对实体排序
const sortEntitys = (entitys) => {
  // 按是否绑表排序
  entitys.sort((a, b) => {
    if (a.deviceId && !b.deviceId) {
      return -1
    }
    if (!a.deviceId && b.deviceId) {
      return 1
    }
    if ((a.deviceId && b.deviceId) || (!a.deviceId && !b.deviceId)) {
      return 0
    }
  })
  // 再按是否在线排序
  entitys.sort((a, b) => {
    if (a.onlineStatus && !b.onlineStatus) {
      return -1
    }
    if (!a.onlineStatus && b.onlineStatus) {
      return 1
    }
    if ((a.onlineStatus && b.onlineStatus) || (!a.onlineStatus && !b.onlineStatus)) {
      return 0
    }
  })
  return entitys
}
// 将机构树和人员信息合并
export const mergeOrgAndEntity = (orgs = [], entitysData = []) => {
  // console.log(orgs)
  let orgTreeData = orgs.map((org) => {
    // console.log(org)
    // 从所有该机构下的实体中找出与该机构link一致的实体
    let entitys = entitysData.filter((entity) => org.link === entity.org_link)
    // 将entitys进行排序
    entitys = sortEntitys(entitys)
    // console.log(entitys)
    // 当前机构含有下级机构
    if (org.hasOwnProperty('children') && org.children.length > 0) {
      mergeOrgAndEntity(org.children, entitysData)
      return {
        name: org.name,
        entitys,
        length: org.length,
        link: org.link,
        is_expand: org.is_expand,
        id: org.id,
        pid: org.pid,
        children: mergeOrgAndEntity(org.children, entitysData)
      }
    } else {
      // 该机构没有下级机构
      return {
        is_expand: org.is_expand,
        name: org.name,
        pid: org.pid,
        length: org.length,
        entitys,
        link: org.link,
        id: org.id,
      }
    }
  })
  return orgTreeData
}

// 获取机构树
const initTreeDefaultProp = (tree, topOrgLevel) => {
  if (tree) {
    tree.map(item => {
      item.is_expand = item.level > topOrgLevel ? false : true
      item.length = 5
      // console.log(item)
      initTreeDefaultProp(item.children, topOrgLevel)
    })
  }
}
const getOrgTree = () => {
  return new Promise((resolve) => {
    axios.get(config.api.org_tree_url).then((res) => {
      if (res.code === 0) {
        const orgTree = [res.result]
        // console.log(this.orgTree)
        let topOrgLevel = orgTree[0].level
        // console.log(topOrgLevel)
        initTreeDefaultProp(orgTree, topOrgLevel)
        resolve(orgTree)
      }
    })
  })
}
// 获取人员数据
const loadData = () => {
  return new Promise((resolve) => {
    axios.get(config.api.entity_map_data_url + '?timestamp=' + 0).then((response) => {
      if (response.code == 0) {
        // console.log(response)
        let entitys = response.result.data
        // console.log(entitys)
        resolve(entitys)
      }
    })
  })
}

// 获取完整的机构树数据
export const getOrgTreeData = () => {
  return new Promise((resolve) => {
    Promise.all([getOrgTree(), loadData()]).then((values) => {
      let tree = mergeOrgAndEntity(...values)
      // console.log(tree)
      resolve(tree)
    })
  })
}
